import { useContext, useEffect, useRef, useState } from 'react';
import T, { t } from '../../../../common/components/T';
import { checkIsfile } from '../../../../common/utils/api';
import UserContext from '../../../../common/utils/getContext';
import { checkFileSize, SITE_URL } from '../../../../common/utils/utils';
import { Img, svgSprite } from '../../../../hybrid/wrappers';
import uikit from '../../../../project/uikit/styles';
import ProgressBar from '../../../ProgressBar/ProgressBar';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';
import css from './FormDropzone.module.scss';

const videoTypes = ['webm', 'mov', 'mp4', 'quicktime'];

function getInfoAboutFile(param, mime) {
    const name = param?.includes('.') ? param?.split('.').splice(0, param?.split('.')?.length - 1) : param;
    const type = mime ? mime?.split('/')?.reverse()[0] : param?.split('.')?.reverse()[0];

    return [name, type];
}

function downloadFileFromBase64(base64String, fileName) {
    try {
        if (!base64String.split('base64,')?.[1]) {
            return false;
        }
        const byteCharacters = atob(base64String.split('base64,')[1]);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        URL.revokeObjectURL(url);
    } catch (e) {
        console.error(e?.message);
    }
}

export const downloadFileFunction =
    (multiple, userToken, lang, setDownload, setCountRequest, setAlertData, setFile) => (link, file) => {
        (async () => {
            if (!link && file) {
                return downloadFileFromBase64(file?.preview, file?.path);
            }
            let headers = {
                Authorization: `Bearer ${userToken}`,
                'Content-Type': 'text/plain',
                Accept: 'application/json',
                ...(lang ? { 'Accept-Language': lang } : {})
            };

            try {
                const response = await fetch(link, {
                    method: 'GET',
                    headers
                });

                let chunks = [];

                if (response.status === 200) {
                    if (response.headers.has('Content-Length')) {
                        const reader = response.body.getReader();

                        while (true) {
                            const { done, value } = await reader.read();

                            if (done) {
                                break;
                            }

                            chunks.push(value);
                        }
                        let blob = new Blob(chunks, { type: file?.mime_type });

                        var myFileRider = new FileReader();
                        myFileRider.onloadend = function () {
                            setDownload(myFileRider.result);
                            setFile(file);
                            setCountRequest(0);
                        };
                        myFileRider.readAsDataURL(blob);
                    } else {
                        if (multiple) {
                            setDownload(file);
                            setFile(file);
                            return;
                        }
                        const data = await response.json();
                        if (!!data?.data?.finished) {
                            if (data?.data?.download_link) {
                                setDownload(data?.data?.download_link);
                                setFile(file);
                            }
                            setCountRequest(0);
                        } else {
                            if (data?.data?.download_link) {
                                setDownload(data?.data?.download_link);
                                setFile(file);
                            }
                            if (data?.data?.queue_link) {
                                // setUrl(data?.data?.queue_link);
                            }
                            setTimeout(() => {
                                setCountRequest((pre) => pre + 1);
                            }, 1500);
                        }
                    }
                } else {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_get_data'
                    });
                    setCountRequest(-1);
                }
            } catch {
                setAlertData({
                    type: 'error',
                    cont: true,
                    default: 'error_get_data'
                });
                setCountRequest(-1);
            }
        })();
    };

export async function fileListToBase64(fileList, maxScale) {
    function getBase64(file) {
        const reader = new FileReader();

        return new Promise((resolve) => {
            if (file.preview || file?.links?.preview || file?.links?.original || file?.url) {
                resolve(file.preview || file?.links?.preview || file?.links?.original || file?.url);
            }
            reader.onload = (ev) => {
                if (!maxScale) {
                    resolve(ev?.target?.result);
                } else {
                    checkFileSize(ev?.target?.result, maxScale).then((result) => resolve(result));
                }
            };
            reader.readAsDataURL(file);
        });
    }
    const promises = [];
    for (let i = 0; i < fileList.length; i++) {
        promises.push(getBase64(fileList[i]));
    }

    return await Promise.all(promises);
}

export async function fileListHeic(fileList, setLoader, setAlertData, translation, setConvertProgress) {
    setLoader('heic');

    function getHeic(file) {
        return new Promise(async (resolve) => {
            if (checkIsfile(file.name, ['heic', 'heif'])) {
                const body = new FormData();
                body.append('upload', file);
                try {
                    const response = await fetch(`${SITE_URL}/api/files/heic`, {
                        method: 'POST',
                        headers: { Accept: 'application/json' },
                        body
                    });
                    let receivedLength = 0;
                    let chunks = [];
                    let contentLength = 0;

                    if (response.status === 200) {
                        const reader = response.body.getReader();
                        contentLength = +response.headers.get('Content-Length');

                        while (true) {
                            const readersrr = await reader.read();
                            const { done, value } = readersrr;
                            if (done) {
                                break;
                            }

                            chunks.push(value);
                            receivedLength += value.length;

                            setConvertProgress(Math.round((receivedLength / contentLength) * 100));
                        }

                        const fileResult = new File(chunks, `${file.name.slice(0, -5) || 'converted'}.jpeg`, {
                            type: 'image/jpeg'
                        });
                        const myFileRider = new FileReader();

                        myFileRider.onload = (ev) =>
                            resolve(
                                Object.assign(fileResult, {
                                    preview: ev.target.result
                                })
                            );
                        myFileRider.readAsDataURL(fileResult);

                        setLoader(false);
                        setAlertData({
                            type: 'success',
                            cont: t(
                                'FormInputDropzone-LoadingFileSucces',
                                'Изображение успешно загружено',
                                'widget',
                                translation,
                                'form'
                            )
                        });
                    }
                } catch {}
            } else {
                resolve(file);
                setLoader(false);

                const [name, type] = getInfoAboutFile(file.name, file.type);
                console.log(name);
                if (type === 'pdf') {
                    setAlertData({
                        type: 'success',
                        cont: t('FormInputDropzone-LoadingFileSucces-pdf', 'Файл успешно загружен', 'widget', translation, 'form')
                    });
                } else if (videoTypes.includes(type)) {
                    setAlertData({
                        type: 'success',
                        cont: t(
                            'FormInputDropzone-LoadingFileSucces-video',
                            'Видео успешно загружено',
                            'widget',
                            translation,
                            'form'
                        )
                    });
                } else {
                    setAlertData({
                        type: 'success',
                        cont: t(
                            'FormInputDropzone-LoadingFileSucces',
                            'Изображение успешно загружено',
                            'widget',
                            translation,
                            'form'
                        )
                    });
                }
            }
        });
    }
    const promises = [];
    for (let i = 0; i < fileList.length; i++) {
        promises.push(fileList[i].url ? fileList[i] : getHeic(fileList[i]));
    }
    return await Promise.all(promises).finally(() => setLoader(false));
}

export const onDropFunction =
    (attribute, multiple, val, maxScale, max, setVal, setFormData, translation, setAlertData, setLoader, setConvertProgress) =>
    async (acceptedFiles) => {
        const allFiles = [...(multiple ? val : []), ...acceptedFiles];
        if (allFiles.length > max) {
            setAlertData({
                type: 'error',
                cont: `${t(
                    'FormInputDropzone-MaxFileCount',
                    'Максимальное количество файлов',
                    'widget',
                    translation,
                    'form'
                )} - ${max}`
            });
            return;
        }
        const arrayOfBase64 = await fileListToBase64(allFiles, maxScale);

        if (arrayOfBase64) {
            const filtered = allFiles.filter((im, ind) => arrayOfBase64[ind]);
            const arrayOfBase64Filtered = arrayOfBase64.filter((im) => typeof im === 'string');
            let newVal = filtered.map((file, index) => {
                return Object.assign(file, {
                    preview: arrayOfBase64Filtered[index] || file?.preview
                });
            });
            const slices = multiple || max ? newVal.slice(0, max || 1) : newVal;
            const converted = await fileListHeic(slices, setLoader, setAlertData, translation, setConvertProgress);

            if (multiple) {
                setVal(converted);
                setFormData(attribute, converted);
            } else {
                setVal(converted?.length ? converted[0] : null);
                setFormData(attribute, converted?.length ? converted[0] : null);
            }

            if (filtered.length > converted.length && max !== 1) {
                setAlertData({
                    type: 'error',
                    cont: `${t(
                        'FormInputDropzone-MaxFileCount',
                        'Максимальное количество файлов',
                        'widget',
                        translation,
                        'form'
                    )} - ${max}`
                });
            }
            if (allFiles.length > filtered.length) {
                setAlertData({
                    type: 'error',
                    cont: `${t(
                        'FormInputDropzone-MaxFileSize',
                        'Максимальный размер файла',
                        'widget',
                        translation,
                        'form'
                    )} - ${maxScale} x ${maxScale}px`
                });
            }
        }
    };

export const plugFileImage = (size, format) => {
    return (
        <svg width={size} height={size} viewBox='0 0 56 56' fill='none'>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M15.68 0H43.68H44.8L56 11.2V12.32V47.04C56 49.5141 53.9941 51.52 51.52 51.52H48.16H44.8H22.4H19.04H15.68C13.2048 51.52 11.2 49.5152 11.2 47.04V42.56V28V20.16H4.48C2.00592 20.16 0 18.1541 0 15.68V10.08C0 7.60592 2.00592 5.6 4.48 5.6H11.2V4.48C11.2 2.00592 13.2059 0 15.68 0ZM38.08 10.08C38.08 7.60592 36.0741 5.6 33.6 5.6C36.0752 5.6 38.08 7.6048 38.08 10.08ZM38.08 15.68C38.08 18.1552 36.0752 20.16 33.6 20.16C36.0741 20.16 38.08 18.1541 38.08 15.68Z'
                fill='#D9DFF3'
            />
            <path
                d='M38.08 10.08V15.68C38.08 18.1541 36.0741 20.16 33.6 20.16H4.48C2.00592 20.16 0 18.1541 0 15.68V10.08C0 7.6059 2.00592 5.59998 4.48 5.59998H33.6C36.0741 5.59998 38.08 7.6059 38.08 10.08Z'
                fill='#435FC5'
            />

            <path
                d='M44.8002 0H43.6802V7.84C43.6802 10.3141 45.6861 12.32 48.1602 12.32H56.0002V11.2L44.8002 0Z'
                fill='#ACB9E6'
            />
            <path d='M5.60035 14.5601H3.36035V16.8001H5.60035V14.5601Z' fill='white' />
            <text fill='#fff' x='7' y='17' style={{ fontSize: '12px', fontWeight: 600 }}>
                {format.slice(0, 4)}
            </text>
        </svg>
    );
};
export const getFilesThumbs = (val, hint, downloading, deleteFunc, downloadFile, transl, compStyle, multiple, exportData) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    return (Array.isArray(val) ? val : val ? [val] : []).map((file, idx) => {
        let [name, type] = getInfoAboutFile(
            file?.name || file?.original_name || file?.path || file?.exportData?.type,
            file?.mime_type
        );
        const size = isNaN(file?.size)
            ? file?.size
            : `${Math.round(file?.size / 1024)} ${t('FormInputDropzone-Kbait', 'КБ', 'widget', transl, 'form')}`;
        return (
            <div
                key={`${file.name}${idx}`}
                style={stylers.fileWrapper}
                className={classnames(classes.fileWrapper, css.fileWrapper)}
            >
                <div style={stylers.fileContainer} className={classnames(classes.fileContainer, css.fileContainer)}>
                    <div className={classnames(classes.filePosition, css.filePosition)} style={stylers.filePosition}>
                        <div className={css.fileIconWrap}>{plugFileImage(56, type?.toUpperCase())}</div>
                        <div className={css.fileInfoWrap}>
                            <p
                                className={classnames(classes.subNamePosition, css.subNamePosition)}
                                style={stylers.subNamePosition}
                            >
                                {name?.length ? name : hint || exportData?.name}
                            </p>
                            {!isNaN(size) && (
                                <p
                                    className={classnames(classes.subSizePosition, css.fileInfoSmall)}
                                    style={stylers.subSizePosition}
                                >
                                    {t('FormInputDropzone-Size', 'Размер', 'widget', transl, 'form')}
                                    {' : '}
                                    {size}
                                </p>
                            )}
                            <p
                                className={classnames(classes.subType2Position, css.fileInfoSmall)}
                                style={stylers.subType2Position}
                            >
                                {t('FormInputDropzone-Format', 'Формат', 'widget', transl, 'form')}
                                {': .'}
                                {type}
                            </p>
                        </div>
                    </div>
                    <div className={classnames(classes.buttonFileWrap, css.buttonFileWrap)} style={stylers.buttonFileWrap}>
                        <div
                            onClick={(e) => {
                                deleteFunc(file, `${idx}`, e);
                            }}
                            className={classnames(css.buttonFile, css.formDropzoneDeleteButton)}
                        >
                            <T textName='delete' defaultStr='Удалить' page='all' />
                        </div>
                        <div
                            className={classnames(css.buttonFile, classes.buttonFile)}
                            onClick={() => {
                                if (!multiple) {
                                    downloadFile(downloading);
                                } else {
                                    downloadFile(file.links?.original || file.url, file);
                                }
                            }}
                        >
                            {t('Download', 'Скачать', 'widget', transl, 'form')}
                        </div>
                    </div>
                </div>
            </div>
        );
    });
};

export const getThumbs = (val, deleteBtn, deleteFunc, downloading, downloadFile, noDrag, css, compStyle) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    return (Array.isArray(val) ? val : val ? [val] : []).map((file, idx) => {
        const isPdf =
            checkIsfile(file?.preview, ['pdf']) ||
            checkIsfile(file?.url, ['pdf']) ||
            checkIsfile(file?.links?.preview, ['pdf']) ||
            checkIsfile(file?.links?.original, ['pdf']) ||
            file?.preview?.includes('data:application/pdf') ||
            file?.url?.includes('data:application/pdf') ||
            file?.links?.preview?.includes('data:application/pdf') ||
            file?.links?.original?.includes('data:application/pdf');
        return (
            <div
                key={`${file.url || file?.links?.preview || file?.links?.original}${file.name}${idx}`}
                className={classnames(classes.previewImageWrap, !noDrag && css.formDropzoneImageWrapper)}
                style={stylers.previewImageWrap}
            >
                {deleteBtn && (
                    <div
                        onClick={(e) => {
                            deleteFunc(file, `${idx}`, e);
                        }}
                        className={css.formDropzoneLoadButtons}
                    >
                        {svgSprite('trash-gt', {
                            width: '24px',
                            height: '24px',
                            fill: 'var(--darkColor)'
                        })}
                    </div>
                )}
                {downloading && (
                    <div
                        onClick={() => {
                            downloadFile(downloading);
                        }}
                        className={css.formDropzoneLoadButtons}
                    >
                        {svgSprite('download', {
                            width: '19px',
                            height: '17px',
                            fill: 'var(--greyExtraDarkColor)'
                        })}
                    </div>
                )}
                <div
                    style={stylers.previewImageContent}
                    className={classnames(css.formDropzoneImageContent, classes.previewImageContent)}
                >
                    {isPdf ? (
                        <div style={{ 'pointer-events': 'none' }}>
                            <iframe
                                src={file?.url || file?.preview || file?.links?.preview || file?.links?.original}
                                height='233px'
                                width='233px'
                            ></iframe>
                        </div>
                    ) : (
                        <Img
                            className={classnames(
                                !noDrag && css.formDropzonePreviewImage,
                                classes.previewImage,
                                !noDrag && !classes.previewImage && classes.styleOfImg
                            )}
                            style={
                                noDrag
                                    ? stylers.previewImage || {}
                                    : {
                                          ...(stylers.previewImage || {
                                              ...stylers.styleOfImg
                                          })
                                      }
                            }
                            src={file.url || file.preview || file?.links?.preview || file?.links?.original}
                        />
                    )}
                </div>
                {noDrag && (
                    <p className={classes.previewName} style={stylers.previewName}>
                        {file.name || file?.original_name || 'flag.png'}
                    </p>
                )}
            </div>
        );
    });
};

export const useDownload = (multiple, exportData) => {
    const { setAlertData, lang, userToken } = useContext(UserContext);

    let [countRequest, setCountRequest] = useState(0);
    const [download, setDownload] = useState(null);
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (download && file && !countRequest) {
            const attribute = multiple ? download?.url || download : download;
            let link = document.createElement('a');
            link.setAttribute('href', attribute);

            link.setAttribute(
                'download',
                multiple
                    ? exportData?.type
                        ? `${exportData?.name}.${exportData?.type}`
                        : download?.fileName || file?.original_name || 'file'
                    : `${exportData?.name}.${exportData?.type}`
            );
            link.click();
        }
    }, [download, file, countRequest, exportData?.name, exportData?.type, multiple]);

    return downloadFileFunction(multiple, userToken, lang, setDownload, setCountRequest, setAlertData, setFile);
};
const BarComponent = ({ refs }) => {
    const { pointerRef, numberRef, progressRef } = refs;
    return (
        <div style={{ ...uikit.mt2, ...uikit.mb2 }}>
            <ProgressBar pointerRef={pointerRef} numberRef={numberRef} progressRef={progressRef} />
        </div>
    );
};
export const useProgress = () => {
    const progressRef = useRef();
    const numberRef = useRef();
    const pointerRef = useRef();
    const setConvertProgress = (progress) => {
        if (progressRef.current) {
            progressRef.current.style.width = `${progress}%`;
        }
        if (numberRef.current) {
            numberRef.current.style.left = `${progress}%`;
            numberRef.current.innerText = `${progress}%`;
        }
        if (pointerRef.current) {
            pointerRef.current.style.left = `${progress}%`;
        }
    };
    return {
        setConvertProgress,
        Bar: () => (
            <BarComponent
                refs={{
                    pointerRef,
                    numberRef,
                    progressRef
                }}
            />
        )
    };
};
